namespace aq.utilityBudgets {
    export class CurrentBillPeriod {
        public billPeriod;
    }
}
angular.module('aq.utilityBudgets').service('CurrentBillPeriod', aq.utilityBudgets.CurrentBillPeriod);
